// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ixezilyqdbarjbqfoczc.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4ZXppbHlxZGJhcmpicWZvY3pjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNjI0ODIsImV4cCI6MjA1ODkzODQ4Mn0.wEIEAjnjuEDb4yyTcYDZnXUJ6PDYZdZTZXv3dFHIDmc'

export const supabase = createClient(supabaseUrl, supabaseKey);
